import type { ReliabilityStatus } from "../domain/types";
import { getReliabilityViewModel } from "../domain/reliability";

interface ProfileStatusBadgeProps {
  status: ReliabilityStatus;
  size?: "sm" | "md";
}

const toneMap: Record<ReliabilityStatus, string> = {
  reliable: "success",
  probably_reliable: "success",
  confirmation_required: "warning",
  degraded: "success",
  incomplete_data: "muted",
  provider_error: "danger",
  private_profile: "private",
  paused_unreliable: "muted",
  unknown: "muted",
};

export function ProfileStatusBadge({ status, size = "md" }: ProfileStatusBadgeProps) {
  const model = getReliabilityViewModel(status);

  return (
    <span
      className={`app-status-pill app-status-${toneMap[status]} app-status-${size}`}
      title={model.description}
    >
      <span />
      {model.title}
    </span>
  );
}
